import { DocumentNode, gql } from '@apollo/client'

export const EMAIL_EXISTS: DocumentNode = gql`
    query EmailExists($email: String!) {
        emailExists(email: $email) {
            userId
            email
            role
            id
            firstname
            lastname
            phone
            address
            city
            zip
            country
            created
            updated
        }
    }
`

export const CHANGE_EMAIL: DocumentNode = gql`
    mutation ChangeEmail($oldEmail: String!, $newEmail: String!) {
        changeEmail(oldEmail: $oldEmail, newEmail: $newEmail)
    }
`

export const DEACTIVATE_EMAIL_ACCOUNT: DocumentNode = gql`
    mutation DeactivateEmailAccount($email: String!) {
        deactivateEmailAccount(email: $email)
    }
`

export const DEACTIVATE_ACCOUNT: DocumentNode = gql`
    mutation DeactiveAccount($userId: Int!, $email: String!) {
        deactiveAccount(userId: $userId, email: $email)
    }
`

export const DEACTIVATE_ACCOUNT_MAIL_NOTIFICATION: DocumentNode = gql`
    mutation DeactivateAccountMailNotification($email: String!, $push: Boolean) {
        deactivateAccountMailNotification(email: $email, push: $push)
    }
`

export const ACTIVATE_ACCOUNT_MAIL_NOTIFICATION: DocumentNode = gql`
    mutation ActivateAccountMailNotification($email: String!, $push: Boolean) {
        activateAccountMailNotification(email: $email, push: $push)
    }
`
